import type { GeneratorConfigV1, Branding, LeadCapture } from '../types/generator-config';

/**
 * Génère une config de base pour un nouveau générateur.
 * L'user personnalisera ensuite via l'éditeur.
 */
export function createDefaultConfig({
    companyName,
    industry,
}: {
    companyName: string;
    industry: string | null;
}): GeneratorConfigV1 {
    const branding: Branding = {
        companyName,
        primaryColor: defaultColorForIndustry(industry),
        logoUrl: null,
        locale: 'fr',
        currency: 'EUR',
    };

    return {
        version: 1,
        branding,
        steps: [],
        pricing: {
            baseAmount: 0,
            rules: [],
        },
        leadCapture: defaultLeadCapture(),
        meta: {},
    };
}

export function defaultLeadCapture(): LeadCapture {
    return {
        enabled: true,
        title: 'Recevez votre devis personnalisé',
        description:
            'Laissez-nous vos coordonnées et nous revenons vers vous sous 24 h avec une proposition détaillée.',
        submitLabel: 'Recevoir mon devis',
        fields: {
            name:    { enabled: true,  required: true  },
            email:   { enabled: true,  required: true  },
            phone:   { enabled: true,  required: true  },
            company: { enabled: false, required: false },
            message: { enabled: true,  required: false },
        },
        consentText:
            "En envoyant ce formulaire, vous acceptez d'être recontacté(e) au sujet de votre demande.",
        successTitle: 'Merci, on vous recontacte !',
        successMessage:
            'Votre demande a bien été envoyée. Nous revenons vers vous très vite avec une proposition personnalisée.',
    };
}

/**
 * Couleur par défaut adaptée au secteur — juste pour un démarrage non-blanc.
 * Très subjectif : l'user changera.
 */
function defaultColorForIndustry(industry: string | null): string {
    const map: Record<string, string> = {
        construction: '#FF8660',
        cleaning: '#0EA5E9',
        moving: '#F59E0B',
        hvac: '#06B6D4',
        electrician: '#F59E0B',
        plumbing: '#3B82F6',
        landscaping: '#22C55E',
        other: '#14B8A6',
    };
    const id = industry ?? 'other';
    return map[id] ?? '#14B8A6';
}
